import ClearFilters from '@/components/ClearFilters/ClearFilters';

export * from '@/components/ClearFilters/types';
export default ClearFilters;
